import { Serializer } from "../serializer"
import { GlobalAttribute } from "./GlobalAttribute"


export class GlobalAttributeSerializer implements Serializer {
    fromJson(json: GlobalAttribute) {
        const item = new GlobalAttribute()
        item.uid = json.uid
        item.value = json.value
        return item
    }
    toJson(item: any) {
        const obj = {}
        return obj
    }
}

